export default __webpack_public_path__ + "static/media/check_circle.afe00fa2.svg";